import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsPdfModule } from '@shared/modules/files/components/pipes/is-pdf/is-pdf.module';
import { IsImageModule } from '@shared/modules/files/components/pipes/is-image/is-image.module';
import { IsVideoModule } from '@shared/modules/files/components/pipes/is-video/is-video.module';
import { AsAsyncModule } from '@shared/ui/pipes/as-async/as-async.module';
import { ImagesComponentsModule } from '@shared/ui/images/images-components.module';
import { CommonAttachmentModule } from '@shared/modules/files/components/common-attachment/common-attachment.module';
import { IconModule } from '@shared/modules/common/icon/icon.module';
import { DropdownModule } from '@shared/ui/dropdown/dropdown.module';
import { SafeModule } from '@dta/ui/pipes/safe/safe.module';
import { FileIconModule } from '@dta/ui/components/common/file-icon/file-icon.module';
import { FileSizeModule } from '@dta/ui/pipes/file-size/file-size.module';
import { ChatCommentAttachmentComponent } from './chat-comment-attachment.component';

@NgModule({
  declarations: [ChatCommentAttachmentComponent],
  imports: [
    CommonModule,
    SafeModule,
    IsPdfModule,
    IsImageModule,
    IsVideoModule,
    AsAsyncModule,
    ImagesComponentsModule,
    FileIconModule,
    FileSizeModule,
    CommonAttachmentModule,
    IconModule,
    DropdownModule
  ],
  exports: [ChatCommentAttachmentComponent]
})
export class ChatCommentAttachmentModule {}
